/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_1_DescInputs */

const en_mk_loop_1_desc = /** @type {(inputs: Mk_Loop_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent gets a Task Packet of ~1–2k tokens: the PRD excerpt, pass criteria, files it may and may not touch, conventions from the wiki.`)
};

const id_mk_loop_1_desc = /** @type {(inputs: Mk_Loop_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent menerima Task Packet ±1–2 rb token: potongan PRD, kriteria lulus, file yang boleh dan dilarang disentuh, konvensi dari wiki.`)
};

/**
* | output |
* | --- |
* | "The agent gets a Task Packet of ~1–2k tokens: the PRD excerpt, pass criteria, files it may and may not touch, conventions from the wiki." |
*
* @param {Mk_Loop_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_1_desc = /** @type {((inputs?: Mk_Loop_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_1_desc(inputs)
	return en_mk_loop_1_desc(inputs)
});